import createReactComponent from '../createReactComponent';
var Scale = createReactComponent('Scale', [['path', {
  d: 'M16 16l3-8 3.001 8A5.002 5.002 0 0116 16z',
  key: '1xxl52'
}], ['path', {
  d: 'M2 16l3-8 3.001 8A5.002 5.002 0 012 16z',
  key: '7ug7ib'
}], ['path', {
  d: 'M7 21h10',
  key: '1b0cd5'
}], ['path', {
  d: 'M12 3v18',
  key: '108xh3'
}], ['path', {
  d: 'M3 7h2c2 0 5-1 7-2 2 1 5 2 7 2h2',
  key: '3gwbw2'
}]]);
export default Scale;